import { UIKioskGlobalSettings } from '@core/models/kiosk-global-settings.model';

export interface KioskGlobalSettingsState {
  settings: UIKioskGlobalSettings;
}

export const KIOSK_GLOBAL_SETTINGS_STORE_KEY = 'KioskGlobalSettings';

export const KIOSK_GLOBAL_SETTINGS_INITIAL_STATE: KioskGlobalSettingsState = {
  settings: {
    stepperProductComposition: {
      autoAddToCart: false,
      hideNextButtonIfTheRequiredQuantityIsOne: false,
    },
    productCard: {
      choice: 1,
      cardColSpan: 1,
      styles: {
        type: 'defaultCard',
      },
    },
    orderingUnavailableModal: { title: '', message: '' },
    multiCurrency: { mode: 'off' },
  },
};
